/**
 * tasks
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * OpenAPI spec version: 2.14
 *
 *
 * NOTE: This class is auto generated by the swagger code generator program.
 * https://github.com/swagger-api/swagger-codegen.git
 * Do not edit the class manually.
 */



export type TaskStatusEnum = 'created' | 'queued' | 'in_progress' | 'stopped' | 'published' | 'publishing' | 'closed' | 'failed' | 'completed' | 'unknown';

export const TaskStatusEnum = {
    Created: 'created' as TaskStatusEnum,
    Queued: 'queued' as TaskStatusEnum,
    InProgress: 'in_progress' as TaskStatusEnum,
    Stopped: 'stopped' as TaskStatusEnum,
    Published: 'published' as TaskStatusEnum,
    Publishing: 'publishing' as TaskStatusEnum,
    Closed: 'closed' as TaskStatusEnum,
    Failed: 'failed' as TaskStatusEnum,
    Completed: 'completed' as TaskStatusEnum,
    Unknown: 'unknown' as TaskStatusEnum
}
